import { Trans, useTranslation } from "react-i18next"

import util from "utils/utils"

export default function IdeaVotedContent({ events, ownerIdea }) {
  const { t } = useTranslation()
  const textSuffix = events[0]?.isFollower ? `${t("generic.ideaWithArticle")} you follow` : `your ${t("generic.idea")}`

  return (
    <Trans
      i18nKey="notifications.ideaVoted"
      values={{
        name: util.getEventNames(events),
        suffix: textSuffix,
        idea: ownerIdea?.name || "Unknown",
      }}
      components={{ b: <b /> }}
    />
  )
}
